import { forwardRef, useMergeRefs } from '@chakra-ui/react';
import { SelectOption } from '@pelicargo/types';
import { useController, useFormContext } from 'react-hook-form';

import { SimpleField, SimpleXProps } from './SimpleField';
import { useSimpleFormContext } from './SimpleForm';
import { TypesenseSelect, TypesenseSelectProps } from './TypesenseSelect';

type SimpleTypesenseSelectProps = Omit<TypesenseSelectProps, 'onChange'> &
  SimpleXProps & {
    defaultValue?: string;
    isPortaled?: boolean;
    title?: string;
  };

export const SimpleTypesenseSelect = forwardRef(({ name, label, helper, ...rest }: SimpleTypesenseSelectProps, ref) => {
  const { simpleOnBlur } = useSimpleFormContext();
  const { control } = useFormContext();
  const {
    field: { onChange, ...fieldProps }, // Extract ref to avoid passing it to ReactSelect
  } = useController({ name, control });

  const localOnChange = (option: SelectOption) => {
    const val = option.value;

    onChange(val === 'undefined' ? undefined : val);
    if ((rest?.ignoreOnBlur !== undefined && !rest.ignoreOnBlur) || rest?.ignoreOnBlur == undefined) {
      simpleOnBlur?.({ target: { name } } as any);
    }
  };

  const mergedRef = useMergeRefs(ref, fieldProps.ref);

  return (
    <SimpleField name={name} label={label} helper={helper} title={rest?.title} ignoreOnBlur={rest?.ignoreOnBlur}>
      <TypesenseSelect onChange={localOnChange} {...fieldProps} {...rest} ref={mergedRef} />
    </SimpleField>
  );
});
